import _ from 'lodash';

const getFormuleChoisie = (data, formules) => {
    return _.find(formules, ['CodeFormule', _.get(data, 'DemandeTarif[Police][FormuleChoisie]')]);
};

export default getFormuleChoisie;
